import { SiteConfigurationState } from "../../store/reducers/siteConfiguration";
import { convertLocalDraftToDateFilters } from "../siteConfiguration/dateFilters";
import { FILTER_TYPE_DATE_PRESETS } from "../constants/constants";

export default {
  local: {
    toRequest: convertLocalToRequest,
  },
};

function convertLocalToRequest(local: SiteConfigurationState) {
  const {
    tenant,
    customPrimaryColor,
    darkThemeEnabled,
    siteName,
    domain,
    dateFilters,
    showHeaderKPI,
    aiRowLimitEnabled,
    filtersUpdateHeaderKPIs,
    menuFilters,
    additionalTheme,
  } = local;

  const dateFiltersApiForm = convertLocalDraftToDateFilters(dateFilters);

  return {
    recacheMenuFiltersNow: "conservative",
    domain,
    siteName,
    darkThemeEnabled: !!darkThemeEnabled,
    customPrimaryColor: customPrimaryColor.checked
      ? customPrimaryColor.color
      : null,
    dateFilters: dateFiltersApiForm ? JSON.stringify(dateFiltersApiForm) : null,
    tenantName: tenant.name,
    description: tenant.description,
    showHeaderKPI,
    aiRowLimitEnabled,
    settings: JSON.stringify({ filtersUpdateHeaderKPIs }),
    additionalTheme: additionalTheme
      ? JSON.stringify({
          ...additionalTheme,
          booleanFilters: additionalTheme.booleanFilters?.filter(Boolean),
        })
      : null,
    preCache: local.preCache,
    menuFilters: menuFilters.checked
      ? menuFilters.list.map((item, index) => {
          const hasDataSource = item.dataSourceUuid && !item.usesCustomValues;
          // send something to labeled values for validation reason
          const isDatePresets = item.type === FILTER_TYPE_DATE_PRESETS;
          const labeledValues = isDatePresets
            ? [{ value: "value", label: "label" }]
            : [];

          return {
            uuid: item.uuid || undefined,
            position: index,
            dataSourceUuid: hasDataSource ? item.dataSourceUuid : undefined,
            dataSourceFieldUuid: hasDataSource
              ? item.dataSourceFieldUuid
              : undefined,
            additionalDataSourceFieldUuids: hasDataSource
              ? item.additionalDataSourceFieldUuids
              : undefined,
            sortDataSourceFieldUuid: item.sortDataSourceFieldUuid || undefined,
            sortOrder: item.sortDataSourceFieldUuid
              ? item.sortOrder ?? "asc"
              : undefined,
            keyDataSourceFieldUuid: item.keyDataSourceFieldUuid,
            displayName: item.displayName,
            type: item.type,
            field: item.usesCustomValues ? item.name : null,
            labeledValues: item.usesCustomValues
              ? (item.labeledValues ?? labeledValues)
                  .filter((item) => item.value)
                  .map((item) => {
                    return {
                      label: item.label || item.value,
                      value: item.value,
                    };
                  })
              : item.labeledValues
              ? []
              : undefined,
            defaultValues: item.defaultValues?.length
              ? item.defaultValues
              : null,
            show: item.show?.length ? item.show : null,
            hide: item.hide?.length ? item.hide : null,
            dependencyParents: item.dependencyParents
              .filter((dependencyParent) => {
                return (
                  !dependencyParent.stagedForDelete &&
                  // This whole parent was staged for deletion.
                  !menuFilters.dependencyParentUuidStagedForDeleteMap[
                    dependencyParent.parentMenuFilterUuid
                  ]
                );
              })
              .map((dependencyParent) => ({
                parentMenuFilterUuid: dependencyParent.parentMenuFilterUuid,
                dataSourceFieldUuid: dependencyParent.dataSourceFieldUuid,
              })),
          };
        })
      : [],
  };
}
